
	export default {
		props: [],
		components: {},
		data: function () {
			return {
				experiences: [],
				showMenu: true,
				fixNav: false,
			};
		},
		computed: {
			navLinkStyle() {
				return this.isMobile
					? this.styleMeClass("vanilla", "StoreFront", "shop-description-text")
					: this.styleMeClass("vanilla", "StoreFront", "title-text");
			},

			navStyle() {
				return this.isMobile
					? this.styleMeClass("vanilla", "StoreFront", "mobile-navigation")
					: this.styleMeClass("vanilla", "StoreFront", "background");
			},

			storeLive() {
				return this.$store.getters.getStoreStatus;
			},

			basketQuantity() {
				return this.$store.getters["basket/getBasket"].length;
			},

			logo() {
				return this.$store.getters.getAccountLogo;
			},

      logoSize() {
        const shouldResize = this.$store.getters.getShouldResizeAccountLogo
        return shouldResize && ['index', 'home'].includes(this.$route.name) ? 'large' : 'small'
      },



			accountWebsite() {
				return this.$store.getters.getAccountWebsite;
			},

			account() {
				return this.$store.getters.getAccount;
			},

    		isMobile() {
				return this.$store.getters.getIsMobile;
			},
		},
		created: function () {
			if (process.client) {
				document
					.getElementById("app")
					.addEventListener("scroll", this.handleScroll);
				document
					.getElementById("app")
					.addEventListener("click", this.handleClick);
				window.addEventListener("resize", this.handleResize);
				window.addEventListener("pageshow", this.handleResize);
				this.handleScroll();
				this.handleResize();
			}
		},

		destroyed() {
			if (process.client) {
				document
					.getElementById("app")
					.removeEventListener("scroll", this.handleScroll);
				document
					.getElementById("app")
					.removeEventListener("click", this.handleClick);
				window.removeEventListener("resize", this.handleResize);
				window.removeEventListener("pageshow", this.handleResize);
			}
		},
		watch: {},
		mounted: function () {
			this.populatePage();
			if (process.client) {
				this.$nextTick(() => {
					this.handleResize();
					if (typeof requestAnimationFrame !== "undefined") {
						requestAnimationFrame(() => this.handleResize());
					}
				});
			}
		},
		methods: {
			handleScroll() {
				if (!document.getElementById("nav-mobile")) return;
				this.fixNav =
					document.getElementById("app").scrollTop > 0 && this.isMobile; //document.getElementById('nav-mobile').clientHeight;
			},

			handleClick(event) {
				if (
					this.isMobile &&
					(this.$refs["store_nav"] === undefined ||
						!this.$refs["store_nav"].contains(event.target) ||
						event.target.id == "overlay")
				)
					this.showMenu = false;
			},

			handleResize() {
				if (!process.client) return;
				if (window.innerWidth > 767) {
					this.showMenu = true;
					this.$store.commit("SET_IS_MOBILE", false);
				} else {
					this.showMenu = false;
					this.$store.commit("SET_IS_MOBILE", true);
				}
			},

			populatePage() {
				this.experiences = this.getExperiences();
			},

			getExperiences() {
				return [
					{
						title: "Meet Mr Penguin",
						image:
							"https://images.mentalfloss.com/sites/default/files/styles/mf_image_16x9/public/istock-511366776.jpg?itok=cWhdWNZ8&resize=1100x619",
						description:
							"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
					},
					{
						title: "Lion Taming Experience",
						image: "https://i.ytimg.com/vi/F6OUZzryHGo/maxresdefault.jpg",
						description:
							"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
					},
					{
						title: "Zoo Tour",
						image: "https://via.placeholder.com/500x300",
						description:
							"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
					},
				];
			},

			hideMenu() {
				if (this.isMobile) {
					this.showMenu = false;
				}
			},

			/*
			 * Hide Menu Event
			 * params event
			 * Check if nav is open, if target clicked is not nav, if is mobile
			 * Close menu
			 */
			hideMenuEvent(event) {
				if (
					typeof this.$refs.nav !== "undefined" && // nav is open
					event.target != this.$refs.nav && // target isn't the nav
					this.isMobile
				) {
					//check is mobile
					this.showMenu = false;
				}
			},
		},
	};
